import React, { useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

import { useNavigate } from "react-router-dom";
import { observer } from "mobx-react";

// ------------------------ SERVICES ------------------------
const allServices = {

  male: {
    Laundry: [
      { name: "CLOTHES", price: 160, unit: "₹/kg", description: "Premium Wash & Fold with Steam Press" },
    ],

   DryClean: [
  { 
    name: "Shirt", 
    price: 150, 
    description: "Premium wash & steam press for formal and casual shirts." 
  },

  { 
    name: "Kurta / Kurti Basic", 
    price: 175, 
    description: "Gentle dry clean for daily-wear kurtis with crisp steam finish." 
  },

  { 
    name: "Kurta / Kurti Designer", 
    price: 250, 
    description: "Premium care for embroidered and designer kurtis with soft steam press." 
  },

  { 
    name: "T-shirt / Top", 
    price: 150, 
    description: "Soft dry clean for delicate tops with premium finishing." 
  },

  { 
    name: "Jacket Blazer Coat", 
    price: 250, 
    description: "Premium dry clean for blazers, jackets, and coats with fabric-safe care." 
  },
  { 
    name: "Blazer / Coat", 
    price: 250, 
    description: "Premium dry clean for blazers, jackets, and coats with fabric-safe care." 
  },

  { 
    name: "Leather Jacket", 
    price: 700, 
    description: "Specialized leather jacket cleaning with shine and texture protection." 
  },

  { 
    name: "Overcoat", 
    price: 400, 
    description: "Deep dry clean for thick winter overcoats with shape protection." 
  },

  { 
    name: "Sweater", 
    price: 250, 
    description: "Soft wool/knitwear wash with anti-stretch fabric care." 
  },

  { 
    name: "Trousers", 
    price: 175, 
    description: "Premium dry clean for trousers with perfect crease finish." 
  },

  { 
    name: "Trousers/Jeans Leather", 
    price: 350, 
    description: "Delicate leather trousers/jeans dry clean with premium finish." 
  },

  { 
    name: "Sherwani Designer Dry Clean", 
    price: 1200, 
    description: "Luxury dry clean for heavy designer sherwanis with embroidery care." 
  },

  { 
    name: "Sherwani Dry Clean", 
    price: 750, 
    description: "Premium sherwani cleaning with color and fabric protection." 
  },

  { 
    name: "Tie Dry Clean", 
    price: 100, 
    description: "Quick delicate cleaning for ties with fabric-safe care." 
  },

  { 
    name: "Waistcoat", 
    price: 300, 
    description: "Premium dry clean for waistcoats with crisp finishing." 
  },

  { 
    name: "Waistcoat Designer", 
    price: 400, 
    description: "Designer waistcoat dry clean with embroidery-safe care." 
  },

  { 
    name: "Bathrobe", 
    price: 200, 
    description: "Soft dry clean for bathrobes with hygiene and freshness treatment." 
  }
]
,

    Iron: [
      { name: "Iron", price: 20, description: "Steam Press" },
    ],

    Shoes: [
      
    {
  name: "Sports Shoes",
  price: 400,
  description: "Deep hygiene clean for sports shoes."
},
{
  name: "Leather Shoes",
  price: 600,
  description: "Premium leather clean and polish finish."
},
{
  name: "Sneakers",
  price: 500,
  description: "White sneaker restoration with premium care."
},
{
  name: "Boots",
  price: 600,
  description: "Deep clean and odor removal for boots."
}

    ],

  Others: [
  { 
    name: "Bedsheet Single", 
    price: 180, 
    description: "Deep wash with premium detergent and full steam-press finish." 
  },

  { 
    name: "Bedsheet Double", 
    price: 220, 
    description: "Complete wash and crisp steam-pressed finishing." 
  },

  { 
    name: "Pillow Cover", 
    price: 175, 
    description: "Gentle fabric-safe wash with smooth wrinkle-free steam finish." 
  },

  { 
    name: "Curtains (per piece)", 
    price: 200, 
    description: "Dust removal, fabric-friendly wash, and antibacterial steam finish." 
  },

  { 
    name: "Comforter / Quilt", 
    price: 400, 
    description: "Heavy-duty wash with germ protection and warm-air drying." 
  },

  { 
    name: "Blanket (Single)", 
    price: 350, 
    description: "Deep clean for wool/acrylic blankets with odor removal." 
  },

  { 
    name: "Blanket (Double)", 
    price: 500, 
    description: "Thorough wash with sanitized drying and fabric protection." 
  },

  { 
    name: "Towel (Bath)", 
    price: 150, 
    description: "Soft antibacterial wash with fresh steam finish." 
  },

  { 
    name: "Towel (Hand/Face)", 
    price: 80, 
    description: "Gentle hygiene wash with disinfection and freshness boost." 
  },

  { 
    name: "Bag Handbag", 
    price: 300, 
    description: "Surface cleaning, deodorizing, and fabric-safe finishing." 
  },

  { 
    name: "Bag School", 
    price: 350, 
    description: "Deep stain removal and complete hygiene wash." 
  },

  { 
    name: "Bag Laptop", 
    price: 350, 
    description: "Dirt-removal wash with structure-safe care and steam finish." 
  },

  { 
    name: "Bag Travel / Duffel", 
    price: 400, 
    description: "Deep clean with stain treatment and deodorizing finish." 
  },

  { 
    name: "Bag Trolley / Duffel", 
    price: 400, 
    description: "Heavy-duty trolley/duffel cleaning with odor removal." 
  },

  { 
    name: "Backpack", 
    price: 275, 
    description: "Deep wash with stain removal and hygiene steam finish." 
  }
]
,
  },

  female: {
    Laundry: [
      { name: "CLOTHES", price: 160, unit: "₹/kg", description: "Premium Wash & Fold with Steam Press" },
    ],

   DryClean: [
  { 
    name: "Kurta / Kurti Basic", 
    price: 175, 
    description: "Gentle dry clean for basic cotton and rayon kurtis with steam press." 
  },

  { 
    name: "Kurta / Kurti Designer", 
    price: 250, 
    description: "Premium care for embroidered and designer kurtis with steam press." 
  },

  { 
    name: "Saree Normal Dry Clean", 
    price: 250, 
    description: "Standard dry clean for daily-wear sarees with crisp steam finish." 
  },

  { 
    name: "Saree Silk Dry Clean", 
    price: 350, 
    description: "Soft dry clean for delicate pure and blended silk sarees." 
  },

  { 
    name: "Saree Designer Dry Clean", 
    price: 700, 
    description: "Premium care for heavy, sequined, and embellished sarees." 
  },

  { 
    name: "Dupatta Dry Clean", 
    price: 200, 
    description: "Gentle dry clean for cotton and light-work dupattas." 
  },

  { 
    name: "Dupatta Designer", 
    price: 350, 
    description: "Delicate cleaning for embroidered and designer dupattas." 
  },

  { 
    name: "Petticoat", 
    price: 250, 
    description: "Soft dry clean for delicate petticoats with steam finish." 
  },

  { 
    name: "Salwar", 
    price: 350, 
    description: "Premium dry clean for embroidered or delicate salwars." 
  },

  { 
    name: "Lehenga Light/Cotton", 
    price: 600, 
    description: "Light-weight lehenga dry clean with fabric-safe care." 
  },

  { 
    name: "Lehenga Party Dry Clean", 
    price: 1500, 
    description: "Luxury dry clean for heavy bridal and designer lehengas." 
  },

  { 
    name: "3pcs Suit Salwar Dupatta", 
    price: 400, 
    description: "Complete 3-piece set dry clean with steam finish." 
  },

  { 
    name: "Party/Heavy 3pcs Suit, Salwar, Dupatta", 
    price: 500, 
    description: "Premium cleaning for heavy or designer 3-piece suits." 
  },

  { 
    name: "Dress", 
    price: 300, 
    description: "Dry clean for casual and semi-formal dresses." 
  },

  { 
    name: "Dress Designer / Party Dress", 
    price: 600, 
    description: "Delicate dry clean for partywear and designer dresses." 
  },

  { 
    name: "Gown Basic Dry Clean", 
    price: 500, 
    description: "Gown dry clean with shape, fabric protection, and steam press." 
  },

  { 
    name: "Gown Designer Dry Clean", 
    price: 1000, 
    description: "Premium cleaning for heavy or designer gowns with shape care." 
  },

  { 
    name: "Skirt / Palazzo", 
    price: 150, 
    description: "Dry clean for skirts and palazzos with crease retention." 
  },

  { 
    name: "T-shirt / Top", 
    price: 150, 
    description: "Soft dry clean for delicate tops with premium finish." 
  },

  { 
    name: "Shorts", 
    price: 150, 
    description: "Premium dry clean for shorts with crisp steam press." 
  },

  { 
    name: "Sweater", 
    price: 250, 
    description: "Wool-safe dry clean with gentle steam finish." 
  },

  { 
    name: "Sweatshirt", 
    price: 150, 
    description: "Gentle dry clean for sweatshirts with premium finish." 
  },

  { 
    name: "Hoodie", 
    price: 200, 
    description: "Delicate hoodie cleaning with crisp steam press." 
  },

  { 
    name: "Jacket/Blazer", 
    price: 250, 
    description: "Premium dry clean for jackets and blazers." 
  },

  { 
    name: "Jacket Leather", 
    price: 700, 
    description: "Luxury leather jacket cleaning with premium finishing." 
  },

  { 
    name: "Trousers/Jeans", 
    price: 150, 
    description: "Soft dry clean for trousers and jeans with steam finish." 
  },

  { 
    name: "Trousers/Jeans Leather", 
    price: 350, 
    description: "Delicate cleaning for leather trousers and jeans." 
  },

  { 
    name: "Blouse", 
    price: 150, 
    description: "Dry clean for blouses with delicate or embroidered work." 
  },
{ 
    name: "Blazer / Coat", 
    price: 250, 
    description: "Premium dry clean for blazers, jackets, and coats with fabric-safe care." 
  },
  { 
    name: "Blouse Designer", 
    price: 250, 
    description: "Premium care for designer and embroidered blouses." 
  }
],


    Iron: [
      { name: "Iron", price: 20, description: "Steam Press" },
    ],

   Shoes: [
  { 
    name: "Heels", 
    price: 350, 
    description: "Premium clean and shine for heels with deodorizing finish." 
  },

  { 
    name: "Sneaker", 
    price: 500, 
    description: "Deep sneaker cleaning with whitening, stain removal & deodorizing." 
  },

  { 
    name: "Sports", 
    price: 400, 
    description: "Sports shoe deep wash with sweat, dirt & odor removal." 
  },

  { 
    name: "Sandals", 
    price: 250, 
    description: "Gentle cleaning for sandals with refreshed look & hygiene care." 
  },

  { 
    name: "Boots", 
    price: 600, 
    description: "Intense boot deep clean with conditioning & premium finish." 
  }
]
,
    Others: [
  { 
    name: "Bedsheet Single", 
    price: 180, 
    description: "Deep wash with premium detergent and full steam-press finish." 
  },

  { 
    name: "Bedsheet Double", 
    price: 220, 
    description: "Complete wash and crisp steam-pressed finishing." 
  },

  { 
    name: "Pillow Cover", 
    price: 175, 
    description: "Gentle fabric-safe wash with smooth wrinkle-free steam finish." 
  },

  { 
    name: "Curtains (per piece)", 
    price: 200, 
    description: "Dust removal, fabric-friendly wash, and antibacterial steam finish." 
  },

  { 
    name: "Comforter / Quilt", 
    price: 400, 
    description: "Heavy-duty wash with germ protection and warm-air drying." 
  },

  { 
    name: "Blanket (Single)", 
    price: 350, 
    description: "Deep clean for wool/acrylic blankets with odor removal." 
  },

  { 
    name: "Blanket (Double)", 
    price: 500, 
    description: "Thorough wash with sanitized drying and fabric protection." 
  },

  { 
    name: "Towel (Bath)", 
    price: 150, 
    description: "Soft antibacterial wash with fresh steam finish." 
  },

  { 
    name: "Towel (Hand/Face)", 
    price: 80, 
    description: "Gentle hygiene wash with disinfection and freshness boost." 
  },

  { 
    name: "Bag Handbag", 
    price: 300, 
    description: "Surface cleaning, deodorizing, and fabric-safe finishing." 
  },

  { 
    name: "Bag School", 
    price: 350, 
    description: "Deep stain removal and complete hygiene wash." 
  },

  { 
    name: "Bag Laptop", 
    price: 350, 
    description: "Dirt-removal wash with structure-safe care and steam finish." 
  },

  { 
    name: "Bag Travel / Duffel", 
    price: 400, 
    description: "Deep clean with stain treatment and deodorizing finish." 
  },

  { 
    name: "Bag Trolley / Duffel", 
    price: 400, 
    description: "Heavy-duty trolley/duffel cleaning with odor removal." 
  },

  { 
    name: "Backpack", 
    price: 275, 
    description: "Deep wash with stain removal and hygiene steam finish." 
  }
]

  },
};

// ---------------------- A–Z ENABLED CATEGORIES ----------------------
const actionsWithAtoZ = ["DryClean", "Shoes", "Others"]; 
// Add new category here → A–Z auto-will work.

const Services = observer(() => {
  const navigate = useNavigate();

  const [activeGender, setActiveGender] = useState("male");
  const [activeAction, setActiveAction] = useState("DryClean");

  const [searchQuery, setSearchQuery] = useState("");
  const [activeLetter, setActiveLetter] = useState("");

  // Show A–Z only for configured categories
  const showAtoZ = actionsWithAtoZ.includes(activeAction);

  const handleBookNow = () => {
    const custId = localStorage.getItem("custId");
    navigate(custId ? "/booking-tabs" : "/login");
  };

  // ---------------------- FILTER LOGIC ----------------------
  let filtered = allServices[activeGender][activeAction];

  // A–Z filter
  if (activeLetter) {
    filtered = filtered.filter((s) =>
      s.name.toUpperCase().startsWith(activeLetter)
    );
  }

  // Search filter
  if (searchQuery.trim()) {
    filtered = filtered.filter((s) =>
      s.name.toLowerCase().includes(searchQuery.toLowerCase())
    );
  }

  const discount = 0.5;

  return (
    <div>
      <Navbar />
     

      <section className="py-12 px-4 md:px-24 bg-gray-50 min-h-screen">
        
        <h2 className="text-center text-3xl font-bold text-yellow-700 mb-6">
          Our Services
        </h2>

        {/* Gender Tabs */}
        <div className="flex justify-center mb-6 gap-4">
          {["male", "female"].map((g) => (
            <button
              key={g}
              onClick={() => {
                setActiveGender(g);
                setActiveAction("DryClean");
                setActiveLetter("");
              }}
              className={`px-6 py-2 rounded-lg font-semibold ${
                activeGender === g ? "bg-green-600 text-white" : "bg-gray-200"
              }`}
            >
              {g.toUpperCase()}
            </button>
          ))}
        </div>

        {/* Action Tabs */}
        {/* Action Dropdown (Single Selector) */}
<div className="flex flex-col items-center mb-4">
  {/* Label */}
  <label 
    className="text-sm font-semibold text-gray-700 mb-1"
  >
    Select Service Type
  </label>

  {/* Dropdown */}
  <select
    value={activeAction}
    onChange={(e) => {
      setActiveAction(e.target.value);
      setActiveLetter("");
    }}
    className="w-48 px-3 py-1.5 border border-gray-300 rounded-md shadow-sm 
               bg-white text-gray-800 text-sm font-medium 
               focus:ring-2 focus:ring-yellow-500"
  >
    <option value="Laundry">Laundry</option>
    <option value="DryClean">Dry Clean</option>
    <option value="Iron">Iron</option>
    <option value="Shoes">Shoes</option>
    <option value="Others">Others</option>
  </select>
</div>


        {/* Search */}
       <div className="flex justify-center mb-4">
  <input
    type="text"
    placeholder="Search items..."
    className="w-full md:w-1/2 px-3 py-1.5 border rounded-md shadow-sm 
               text-sm"
    value={searchQuery}
    onChange={(e) => setSearchQuery(e.target.value)}
  />
</div>


        {/* A–Z BAR */}
        {/* A–Z BAR */}
{showAtoZ && (
  <div className="flex flex-wrap justify-center gap-2 mb-6">

    {/* Alphabet Buttons */}
   <div className="flex overflow-x-auto no-scrollbar justify-center gap-0.5 sm:gap-1 mb-3 flex-wrap max-h-16">
  {"ABCDEFGHIJKLMNOPQRSTUVWXYZ".split("").map((letter) => {
    const hasItems = allServices[activeGender][activeAction].some((s) =>
      s.name.toUpperCase().startsWith(letter)
    );

    return (
      <button
        key={letter}
        disabled={!hasItems}
        onClick={() => hasItems && setActiveLetter(letter)}
        className={`px-1.5 py-[2px] text-[10px] leading-none border rounded 
          ${!hasItems 
            ? "bg-gray-200 text-gray-400 cursor-not-allowed"
            : activeLetter === letter
              ? "bg-black text-yellow-400 border-black"
              : "bg-white hover:bg-yellow-100"
          }`}
      >
        {letter}
      </button>
    );
  })}
</div>



    {/* ALL BUTTON */}
    <button
      onClick={() => setActiveLetter("")}
      className={`px-3 py-1 border rounded-md 
        ${activeLetter === "" 
          ? "bg-black text-yellow-400" 
          : "bg-white hover:bg-yellow-100"
        }`}
    >
      ALL
    </button>

  </div>
)}

        {/* SERVICES GRID */}
        <div className="grid gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 xl:grid-cols-6">
          {filtered.map((service) => {
            const finalPrice = Math.round(service.price * discount);

            return (
              <div key={service.name} className="bg-white p-5 rounded-lg shadow">
                <h3 className="text-lg font-semibold mb-1">{service.name}</h3>
                <p className="text-gray-600 text-sm mb-3">{service.description}</p>

               <div className="flex items-center gap-2">
  <span className="line-through text-gray-400">₹{service.price}</span>

  <span className="text-green-600 text-xl font-bold">
    ₹{finalPrice}
  </span>

  {/* SHOW UNIT IF AVAILABLE */}
  {service.unit && (
    <span className="text-sm text-gray-600">
      {service.unit}
    </span>
  )}
</div>


                <button
                  onClick={handleBookNow}
                  className="w-full mt-3 p-2 border border-yellow-600 rounded-lg text-yellow-700 hover:bg-black hover:text-yellow-400 transition"
                >
                  Book Now
                </button>
              </div>
            );
          })}
        </div>
      </section>

      <Footer />
    </div>
  );
});

export default Services;
